/* jshint ignore:start */
import Component from 'metal-component';
import Soy from 'metal-soy';

var templates;
goog.loadModule(function(exports) {
var soy = goog.require('soy');
var soydata = goog.require('soydata');
// This file was automatically generated from FieldSet.soy.
// Please don't edit this file by hand.

/**
 * @fileoverview Templates in namespace FieldSet.
 * @public
 */

goog.module('FieldSet.incrementaldom');

goog.require('goog.soy.data.SanitizedContent');
var incrementalDom = goog.require('incrementaldom');
goog.require('soy.asserts');
var soyIdom = goog.require('soy.idom');

var $templateAlias1 = Soy.getTemplate('FieldBase.incrementaldom', 'render');

var $templateAlias2 = Soy.getTemplate('PageRenderer.incrementaldom', 'rows');


/**
 * @param {{
 *  activePage: number,
 *  name: (!goog.soy.data.SanitizedContent|string),
 *  spritemap: (!goog.soy.data.SanitizedContent|string),
 *  _handleFieldBlurred: (*|null|undefined),
 *  _handleFieldEdited: (*|null|undefined),
 *  _handleFieldFocused: (*|null|undefined),
 *  displayErrors: (boolean|null|undefined),
 *  editable: (boolean|null|undefined),
 *  errorMessage: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  id: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  label: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  nestedRows: (!Array<?>|null|undefined),
 *  pageIndex: (null|number|undefined),
 *  readOnly: (boolean|null|undefined),
 *  repeatable: (boolean|null|undefined),
 *  required: (boolean|null|undefined),
 *  showLabel: (boolean|null|undefined),
 *  tip: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  tooltip: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  valid: (boolean|null|undefined),
 *  visible: (boolean|null|undefined)
 * }} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes}
 */
function $render(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  var $$temp;
  /** @type {number} */
  var activePage = soy.asserts.assertType(goog.isNumber(opt_data.activePage), 'activePage', opt_data.activePage, 'number');
  /** @type {!goog.soy.data.SanitizedContent|string} */
  var name = soy.asserts.assertType(goog.isString(opt_data.name) || opt_data.name instanceof goog.soy.data.SanitizedContent, 'name', opt_data.name, '!goog.soy.data.SanitizedContent|string');
  /** @type {!goog.soy.data.SanitizedContent|string} */
  var spritemap = soy.asserts.assertType(goog.isString(opt_data.spritemap) || opt_data.spritemap instanceof goog.soy.data.SanitizedContent, 'spritemap', opt_data.spritemap, '!goog.soy.data.SanitizedContent|string');
  /** @type {*|null|undefined} */
  var _handleFieldBlurred = opt_data._handleFieldBlurred;
  /** @type {*|null|undefined} */
  var _handleFieldEdited = opt_data._handleFieldEdited;
  /** @type {*|null|undefined} */
  var _handleFieldFocused = opt_data._handleFieldFocused;
  /** @type {boolean|null|undefined} */
  var displayErrors = soy.asserts.assertType(opt_data.displayErrors == null || (goog.isBoolean(opt_data.displayErrors) || opt_data.displayErrors === 1 || opt_data.displayErrors === 0), 'displayErrors', opt_data.displayErrors, 'boolean|null|undefined');
  /** @type {boolean|null|undefined} */
  var editable = soy.asserts.assertType(opt_data.editable == null || (goog.isBoolean(opt_data.editable) || opt_data.editable === 1 || opt_data.editable === 0), 'editable', opt_data.editable, 'boolean|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var errorMessage = soy.asserts.assertType(opt_data.errorMessage == null || (goog.isString(opt_data.errorMessage) || opt_data.errorMessage instanceof goog.soy.data.SanitizedContent), 'errorMessage', opt_data.errorMessage, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var id = soy.asserts.assertType(opt_data.id == null || (goog.isString(opt_data.id) || opt_data.id instanceof goog.soy.data.SanitizedContent), 'id', opt_data.id, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var label = soy.asserts.assertType(opt_data.label == null || (goog.isString(opt_data.label) || opt_data.label instanceof goog.soy.data.SanitizedContent), 'label', opt_data.label, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!Array<?>|null|undefined} */
  var nestedRows = soy.asserts.assertType(opt_data.nestedRows == null || goog.isArray(opt_data.nestedRows), 'nestedRows', opt_data.nestedRows, '!Array<?>|null|undefined');
  /** @type {null|number|undefined} */
  var pageIndex = soy.asserts.assertType(opt_data.pageIndex == null || goog.isNumber(opt_data.pageIndex), 'pageIndex', opt_data.pageIndex, 'null|number|undefined');
  /** @type {boolean|null|undefined} */
  var readOnly = soy.asserts.assertType(opt_data.readOnly == null || (goog.isBoolean(opt_data.readOnly) || opt_data.readOnly === 1 || opt_data.readOnly === 0), 'readOnly', opt_data.readOnly, 'boolean|null|undefined');
  /** @type {boolean|null|undefined} */
  var repeatable = soy.asserts.assertType(opt_data.repeatable == null || (goog.isBoolean(opt_data.repeatable) || opt_data.repeatable === 1 || opt_data.repeatable === 0), 'repeatable', opt_data.repeatable, 'boolean|null|undefined');
  /** @type {boolean|null|undefined} */
  var required = soy.asserts.assertType(opt_data.required == null || (goog.isBoolean(opt_data.required) || opt_data.required === 1 || opt_data.required === 0), 'required', opt_data.required, 'boolean|null|undefined');
  /** @type {boolean|null|undefined} */
  var showLabel = soy.asserts.assertType(opt_data.showLabel == null || (goog.isBoolean(opt_data.showLabel) || opt_data.showLabel === 1 || opt_data.showLabel === 0), 'showLabel', opt_data.showLabel, 'boolean|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var tip = soy.asserts.assertType(opt_data.tip == null || (goog.isString(opt_data.tip) || opt_data.tip instanceof goog.soy.data.SanitizedContent), 'tip', opt_data.tip, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var tooltip = soy.asserts.assertType(opt_data.tooltip == null || (goog.isString(opt_data.tooltip) || opt_data.tooltip instanceof goog.soy.data.SanitizedContent), 'tooltip', opt_data.tooltip, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {boolean|null|undefined} */
  var valid = soy.asserts.assertType(opt_data.valid == null || (goog.isBoolean(opt_data.valid) || opt_data.valid === 1 || opt_data.valid === 0), 'valid', opt_data.valid, 'boolean|null|undefined');
  /** @type {boolean|null|undefined} */
  var visible = soy.asserts.assertType(opt_data.visible == null || (goog.isBoolean(opt_data.visible) || opt_data.visible === 1 || opt_data.visible === 0), 'visible', opt_data.visible, 'boolean|null|undefined');
  var param2248 = function() {
    if (showLabel) {
      incrementalDom.elementOpenStart('label');
          incrementalDom.attr('class', 'text-uppercase');
      incrementalDom.elementOpenEnd();
        soyIdom.print(label);
      incrementalDom.elementClose('label');
      incrementalDom.elementOpenStart('div');
          incrementalDom.attr('class', 'mt-1 separator');
      incrementalDom.elementOpenEnd();
      incrementalDom.elementClose('div');
    }
    $templateAlias2({_handleFieldBlurred: _handleFieldBlurred, _handleFieldEdited: _handleFieldEdited, _handleFieldFocused: _handleFieldFocused, activePage: activePage, editable: editable, pageIndex: pageIndex, rows: ($$temp = nestedRows) == null ? [] : $$temp, spritemap: spritemap}, null, opt_ijData);
  };
  $templateAlias1({contentRenderer: param2248, displayErrors: displayErrors, errorMessage: errorMessage, id: id, label: label, name: name, readOnly: readOnly, repeatable: repeatable, required: required, showLabel: false, spritemap: spritemap, tip: tip, tooltip: tooltip, valid: valid, visible: visible}, null, opt_ijData);
}
exports.render = $render;
/**
 * @typedef {{
 *  activePage: number,
 *  name: (!goog.soy.data.SanitizedContent|string),
 *  spritemap: (!goog.soy.data.SanitizedContent|string),
 *  _handleFieldBlurred: (*|null|undefined),
 *  _handleFieldEdited: (*|null|undefined),
 *  _handleFieldFocused: (*|null|undefined),
 *  displayErrors: (boolean|null|undefined),
 *  editable: (boolean|null|undefined),
 *  errorMessage: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  id: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  label: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  nestedRows: (!Array<?>|null|undefined),
 *  pageIndex: (null|number|undefined),
 *  readOnly: (boolean|null|undefined),
 *  repeatable: (boolean|null|undefined),
 *  required: (boolean|null|undefined),
 *  showLabel: (boolean|null|undefined),
 *  tip: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  tooltip: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  valid: (boolean|null|undefined),
 *  visible: (boolean|null|undefined)
 * }}
 */
$render.Params;
if (goog.DEBUG) {
  $render.soyTemplateName = 'FieldSet.render';
}

exports.render.params = ["activePage","name","spritemap","_handleFieldBlurred","_handleFieldEdited","_handleFieldFocused","displayErrors","editable","errorMessage","id","label","nestedRows","pageIndex","readOnly","repeatable","required","showLabel","tip","tooltip","valid","visible"];
exports.render.types = {"activePage":"number","name":"string","spritemap":"string","_handleFieldBlurred":"any","_handleFieldEdited":"any","_handleFieldFocused":"any","displayErrors":"bool","editable":"bool","errorMessage":"string","id":"string","label":"string","nestedRows":"list<?>","pageIndex":"number","readOnly":"bool","repeatable":"bool","required":"bool","showLabel":"bool","tip":"string","tooltip":"string","valid":"bool","visible":"bool"};
templates = exports;
return exports;

});

class FieldSet extends Component {}
Soy.register(FieldSet, templates);
export { FieldSet, templates };
export default templates;
/* jshint ignore:end */
